// utils/asignarAdmin.ts

import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../firebase";

export const asignarAdmin = async (email: string) => {
	const functions = getFunctions(app);
	const setAdminRole = httpsCallable(functions, "setAdminRole");

	try {
		const res = await setAdminRole({ email });
		return res.data;
	} catch (error: any) {
		throw new Error(error.message || "Error al asignar rol de administrador.");
	}
};
